import { useContext, useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import { Form, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { HiMagnifyingGlass } from "react-icons/hi2";
import InputGroup from "react-bootstrap/InputGroup";
import { Ucontext } from "../context/Ucontext";
import Loading from "../components/loader/Loading";
import {
  getAllAgencies,
  getCreditTransactions,
} from "../context/functions/AdminFunction";
import moment from "moment";
import { haveValue } from "../utils/common";
import Pagination from "../components/Pagination";

const CreditsReport = () => {
  const { adminDispatch, adminState } = useContext(Ucontext);
  const queryParameters = new URLSearchParams(window.location.search);

  const { totalCreditTransactions } = adminState;
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [agencyDetails, setAgencyDetails] = useState([]);
  const [joinedFromList, setJoinedFromList] = useState([]);
  const abortControllerRef = useRef(null);

  const [filter, setFilter] = useState({
    agency: "",
    status: "",
    type: "",
  });

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    loadCreditTransactions(currentPage, searchVal, filter, controller.signal);

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [currentPage, searchVal, filter]);

  useEffect(() => {
    getAllAgencies()
      .then((res) => {
        const data = res.data.success_res;
        setAgencyDetails(data);
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const loadCreditTransactions = async (currentPage, searchVal, filter, signal = null) => {
    setLoading(true);
    const { status, agency = "", type, landlord_id } = filter;

    let response = await getCreditTransactions(
      currentPage,
      searchVal,
      agency,
      status,
      type,
      landlord_id,
      signal
    );

    if (response?.status === "canceled") {
      return;
    }

    if (response.success == true) {
      adminDispatch({
        type: "CREDIT_TRANSACTIONS_LOADED",
        payload: response?.data,
      });
      setTotalPages(response?.totalPages);
    }
    setLoading(false);
  };

  let interval;
  const handleSearch = (e) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setSearchVal(e.target.value);
      setcurrentPage(1);
    }, 500);
  };

  const handlePageClick = (event) => {
    setcurrentPage(event.selected + 1);
  };

  const handleClickFilter = (e) => {
    setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setcurrentPage(1);
  };

  return (
    <>
      <div className="data-main">
        <div className="data-header-box">
          <div className="header_table d-flex justify-content-between align-items-center">
            <h1>Credit Transactions</h1>
          </div>

          <div className="d-flex justify-content-around lanloard-admin-filter">
            <div className="searchbar_table landloard-filter-box">
              <div>
                <h5>Agency</h5>
                <Form.Select
                  onChange={handleClickFilter}
                  name="agency"
                  id="agency"
                >
                  <option value="">All</option>
                  {agencyDetails.map(
                    (detail) =>
                      haveValue(detail?.company_name) && (
                        <option value={detail?._id}>
                          {detail?.company_name}
                        </option>
                      )
                  )}
                </Form.Select>
              </div>
              <div>
                <h5>Status</h5>
                <Form.Select
                  onChange={handleClickFilter}
                  name="status"
                  id="status"
                >
                  <option value="">All</option>
                  <option value="completed">Completed</option>
                  <option value="pending">Pending</option>
                  <option value="processing">Processing</option>
                  <option value="failed">Failed</option>
                </Form.Select>
              </div>
              <div>
                <h5>Type</h5>
                <Form.Select onChange={handleClickFilter} name="type" id="type">
                  <option value="">All</option>
                  <option value="debit">Debit</option>
                  <option value="credit">Credit</option>
                </Form.Select>
              </div>

              <div>
                <InputGroup className="input_table_header ">
                  <InputGroup.Text id="basic-addon1">
                    <HiMagnifyingGlass />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    // value={searchVal}
                    defaultValue={
                      haveValue(queryParameters.get("email"))
                        ? queryParameters.get("email")
                        : ""
                    }
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        </div>

        <Table responsive hover>
          <thead className="landloar-tabel-head">
            <tr>
              <th>Transaction Type</th>
              <th>Credit</th>
              <th>Amount</th>
              <th>Landlord Name</th>
              <th>Agency Name</th>
              <th>Status</th>
              <th>Transaction Id</th>
              <th>Processing Date</th>
            </tr>
          </thead>
          <tbody className="landloar-tabel-head">
            {loading ? <Loading /> : null}
            {totalCreditTransactions &&
              totalCreditTransactions.map((data, index) => (
                <tr key={data?._id}>
                  <td className="text-capitalize">{data?.type ?? "-"}</td>
                  <td>{data?.credit ?? "-"}</td>
                  <td>{data?.amount ?? "-"}</td>
                  <td>
                    {data?.landlord_id?.fname_companyName ?? "-"}{" "}
                    {data?.landlord_id?.lname ?? ""}
                  </td>
                  <td>{data?.landlord_id?.agency_id?.company_name ?? "-"} </td>
                  <td className="text-capitalize">{data?.status ?? "-"}</td>
                  <td>{data?.transaction_id ?? "-"}</td>
                  <td>
                    {moment(data.processing_date).format(
                      "DD MMMM YYYY, HH:mm:ss"
                    )}
                  </td>
                </tr>
              ))}
            {totalCreditTransactions?.length === 0 && (
              <tr>
                <td colSpan={10} className="">
                  No Data Found!
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          currentPage={currentPage - 1}
          totalPages={totalPages}
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
        />
      </div>
    </>
  );
};

export default CreditsReport;
